// @flow
import * as React from 'react';
import cx from 'classnames';
import classNames from 'classnames/bind';
import Row from '../../basic-components/table/row';
import Cell from '../../basic-components/table/cell';
import Thumbnail from '../../basic-components/thumbnail';
import catchMouseFocus from '../../utils/hocs/catch-mouse-focus';
import ClickToCopy from '../../basic-components/click-to-copy';
import Checkbox from '../../basic-components/checkbox';
import { flex } from '../stock-table/flexconfig';
import { ellipsisize } from '../../utils/string';
import cs from './styles.pcss';

import type { Products_products_nodes_variations as VariationT } from '../../typings/product-query.flow';

const csx = classNames.bind(cs);

type Props = {
  variation: VariationT,
  onClick: () => void,
  checked: boolean,
  onToggle: (id: string) => void,
  productId: string,
  showcasesLength: number,
  changed?: boolean,
  success?: boolean,
  error?: boolean,
};

const ThumbButton = catchMouseFocus((props) => (
  <button type="button" {...props} />
));

export default function VariationRow({
  variation,
  onClick,
  checked,
  onToggle,
  showcasesLength,
  changed,
  success,
  error,
}: Props): React.Node {
  const { id, thumbnail, quantity, title, sku } = variation;

  const handleChange = () => {
    onToggle(id);
  };

  return (
    <Row
      largePadding
      className={csx('variation-row')}
      changed={changed}
      success={success}
      error={error}
      checked={checked}
    >
      <Cell
        {...flex('title')}
        className={cx(csx('cell'), csx('clickable'))}
        onClick={onClick}
      >
        <Checkbox
          checked={checked}
          onClick={(event) => {
            event.stopPropagation();
          }}
          className={csx('variationCheckbox')}
          onChange={handleChange}
        />

        <ThumbButton onClick={onClick} className={csx('thumb')}>
          <Thumbnail src={thumbnail || null} alt={title} />
        </ThumbButton>

        <div className={csx('ellipsis')}>{title}</div>
      </Cell>
      <Cell {...flex('sku')} className={cx(csx('cell'), csx('sku-cell'))}>
        {sku ? (
          <ClickToCopy textToCopy={sku}>{ellipsisize(sku, 7)}</ClickToCopy>
        ) : null}
      </Cell>
      <>
        <Cell className={csx('cell')} {...flex('amount')}>
          <div className={csx('quantity-display')}>{quantity || 0}</div>
        </Cell>
        {/* 拆分成多个 Cell 以匹配 product row 的 padding */}
        {/* eslint-disable react/no-array-index-key */}
        {Array.from({ length: showcasesLength }).map((_, index) => (
          <Cell
            key={`empty-${id}-${index}`}
            className={csx('cell')}
            {...flex('listing')}
          />
        ))}
        {/* eslint-enable react/no-array-index-key */}
      </>
    </Row>
  );
}
